import { createAction } from '@reduxjs/toolkit';

// Action to reset the entire Redux state
export const resetForLoading = createAction('resetForLoading');
export const resetAll = createAction('resetAll');
